import { render, staticRenderFns } from "./Language.vue?vue&type=template&id=9f346616&scoped=true&lang=pug&"
import script from "./Language.vue?vue&type=script&lang=js&"
export * from "./Language.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f346616",
  null
  
)

export default component.exports